// takes number and returns currency string as dollar amount (1234 => '$1,234')
export const numToCurrency = (_num: number): string => {
  return _num.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
};

// takes number as fraction and returns precent as string (0.035 => '3.5%')
export const numToPercentage = (_num: number): string => {
  const num = _num * 100;
  return `${num.toFixed(1)}%`;
};
